import { z } from 'zod/v4';
export const UpdateSchema = z.object({
    name: z.string().optional(),
    users: z
        .array(z.object({
        userId: z.uuid(),
        addedAt: z.string().nullish(),
        addedByUserId: z.string().nullish(),
    }))
        .optional(),
});
export const CreateSchema = z.object({
    name: z.string(),
});
export const ResponsibleSchema = z.object({
    type: z.enum(['user', 'team']),
    referenceId: z.string().nullable(),
});
export const ResponsibleForUpdateTypesSchema = z.object({
    catchAll: ResponsibleSchema.nullable(),
    updateTypes: z.record(z.string(), ResponsibleSchema.nullable()),
});
//# sourceMappingURL=index.js.map